import { Component, OnInit,Input,EventEmitter,Output,OnChanges,SimpleChanges,ElementRef,HostListener } from '@angular/core';
import * as _ from 'lodash';
import { StorePouchDb } from '../../store.pouchdb.service';
import { Constants } from '../../../shared/models/constants';
import { IS_ElectronService } from '../../../shared/IS_Electron.service';

@Component({
  selector: 'app-storeSearchResults',
  templateUrl: './storeSearchResults.component.html',
  styleUrls: ['./storeSearchResults.component.css']
})
export class StoreSearchResultsComponent implements OnInit {
  @Input() storeContent: any;
  @Input() searchItem:any;
  @Output() closingSearchEvent = new EventEmitter<any>();
  matchedStores = [];
  matchedBooks = [];
  public selectebookIndex;
   matchedSubStores = [];
   containerWidth = 10;
   counter = Array;
   Math: any;
   gridToggleIcon = 'icon-BottomButton';
   selectedGridViewInd = undefined;

   @HostListener('window:resize') onResize() {
    this.windowResized();
  }

  constructor(public pouchservice:StorePouchDb, private ElectronService: IS_ElectronService, private ele: ElementRef) {
    this.Math = Math;
   }

  ngOnInit() { 
    this.updateSearchedContent();

  }
closeSearchResults(){
  this.closingSearchEvent.emit('close');
}

updateSearchedContent(){
  var self = this;
  this.matchedStores = _.filter(this.storeContent.getStores.stores, function (filter) { return filter.englishStoreName.toLowerCase().includes(self.searchItem.toLowerCase())  && filter.parentStoreId == ""  })

  this.matchedSubStores = _.filter(this.storeContent.getStores.stores, function (filter) { return filter.englishStoreName.toLowerCase().includes(self.searchItem.toLowerCase())  && filter.parentStoreId != ""  })

//  this.matchedBooks = _.filter(this.storeContent.privateAppStores.storeContent, function (filter) { return filter.title.toLowerCase().includes(self.searchItem.toLowerCase()) ||  filter.author.toLowerCase().includes(self.searchItem.toLowerCase()) })
//  this.matchedBooks = _.uniqBy(this.matchedBooks, 'publishId');
}

ngOnChanges(changes: SimpleChanges) {
  this.searchItem = changes.searchItem.currentValue;
  this.updateSearchedContent();

  // var temp = JSON.parse(localStorage.purchasesList);
  // this.pouchservice.getBookData(this, temp);
}

getSubStoreData(store,isSubstore){
  var temp = {
    state : 'Stores',
    obj:store
  }
if(isSubstore){
  temp.state = 'Sub Stores'
}
  this.closingSearchEvent.emit(temp);
}


displayStoreBookDetails(ev,book){
 let temp = {
  state : 'BookDetails',
  obj:book,
  ev:ev
  }

  this.closingSearchEvent.emit(temp);
}

// downloadedBooks(data) {
//   for (var i = 0; i < this.matchedBooks.length; i++) {
//     let temp = Constants.USER + "." + this.matchedBooks[i].publishId + ".book";
//     var ind = _.indexOf(_.map(data, '_id'), temp);
//     if (ind > -1) {
//       this.matchedBooks[i].downloaded = true;
//     }
//   }
// }

 saveBookToPurchases(book,state){
   this.selectebookIndex = book.publishId;
   if(state == false){
    book.downloaded = true;
   }

   let temp = {
    state : 'downloadBook',
    obj:book,
    isDownloaded:state
    }
    this.closingSearchEvent.emit(temp);
 }

 showGridView(ind){

  if(ind == this.selectedGridViewInd){
    this.selectedGridViewInd = undefined;
    this.gridToggleIcon = 'icon-BottomButton';
  }else{
    this.selectedGridViewInd = ind;
    this.gridToggleIcon = 'icon-TopButton';
  }

 }

 showStoresNextIcon(count){
  this.containerWidth = this.ele.nativeElement.querySelector('.searchResultsArea').offsetWidth;
  if(count * 160 > this.containerWidth){
    return true;
  }else{
    return false;
  }
 }

 showBooksNextIcon(count){
  this.containerWidth = this.ele.nativeElement.querySelector('.searchResultsArea').offsetWidth;
  if(count * 180 > this.containerWidth){
    return true;
  }else{
    return false;
  }
 }

 windowResized(){

  let navigationContainers = this.ele.nativeElement.querySelectorAll('.scrollNavigationContainer');
  for(var j = 0;j < navigationContainers.length; j++){
      let navigationbars = navigationContainers[j].querySelectorAll('.booksNavigation');
      let activeNavBarInd = 0;
    for (let i = 0; i < navigationbars.length; i++) {
      if (navigationbars[i].classList.contains('activeScrollBar')) {
        activeNavBarInd = i;
      }
    }
    navigationbars[activeNavBarInd].classList.remove('activeScrollBar');
    navigationbars[0].classList.add('activeScrollBar');
  }

  this.ele.nativeElement.querySelector('.searchedStoresContainer').scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  this.ele.nativeElement.querySelector('.searchedSubStoresContainer').scrollTo({ left: 0, top: 0, behavior: 'smooth' });

 }

 displayPrevOption(con){
  let currentContainer = this.ele.nativeElement.querySelector('.'+con);
  let currentConScrollLeft = currentContainer.scrollLeft;
  let newScrollLeft = currentConScrollLeft+this.containerWidth;

  let activeNavBarInd = 0;
  let navigationbars = currentContainer.querySelectorAll('.booksNavigation')
  for (let i = 0; i < navigationbars.length; i++) {
   if (navigationbars[i].classList.contains('activeScrollBar')) {
     activeNavBarInd = i;
   }
 }

 if(activeNavBarInd != 0){
   return true;
 }
 else{
   return false;
 }
 }

 onStoresNext(con){
   let currentContainer = this.ele.nativeElement.querySelector('.'+con);
   let currentConScrollLeft = currentContainer.scrollLeft;
   let newScrollLeft = currentConScrollLeft+this.containerWidth;

   let activeNavBarInd = 0;
   let navigationbars = currentContainer.querySelectorAll('.booksNavigation')
   for (let i = 0; i < navigationbars.length; i++) {
    if (navigationbars[i].classList.contains('activeScrollBar')) {
      activeNavBarInd = i;
    }
  }

  if(navigationbars[activeNavBarInd+1]){
    navigationbars[activeNavBarInd].classList.remove('activeScrollBar');
    navigationbars[activeNavBarInd+1].classList.add('activeScrollBar');
    currentContainer.scrollTo({ left: newScrollLeft, top: 0, behavior: 'smooth' });
  }else{
    navigationbars[activeNavBarInd].classList.remove('activeScrollBar');
    navigationbars[0].classList.add('activeScrollBar');
    currentContainer.scrollTo({ left: 0, top: 0, behavior: 'smooth' });
  }

 }

 onStoresPrevious(con){


  let currentContainer = this.ele.nativeElement.querySelector('.'+con);
  let currentConScrollLeft = currentContainer.scrollLeft;
  let newScrollLeft = currentConScrollLeft - this.containerWidth;

  let activeNavBarInd = 0;
  let navigationbars = currentContainer.querySelectorAll('.booksNavigation')
  for (let i = 0; i < navigationbars.length; i++) {
   if (navigationbars[i].classList.contains('activeScrollBar')) {
     activeNavBarInd = i;
   }
 }

 if(navigationbars[activeNavBarInd - 1]){
   navigationbars[activeNavBarInd].classList.remove('activeScrollBar');
   navigationbars[activeNavBarInd - 1].classList.add('activeScrollBar');
   currentContainer.scrollTo({ left: newScrollLeft, top: 0, behavior: 'smooth' });
 }
 }


}



// WEBPACK FOOTER //
// ./src/app/store/popups/storeSearchResults/storeSearchResults.component.ts